import type { FAQItem } from '../../types/faq';

interface Input {
  url: string;
  faqItems?: FAQItem[];
}

export const buildFAQPage = ({ url, faqItems }: Input) => {
  if (!faqItems || faqItems.length === 0) return null;
  return {
    '@type': 'FAQPage',
    '@id': `${url}#faqpage`,
    mainEntity: faqItems
      .filter((item) => item.schemaAnswer)
      .map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.schemaAnswer,
        },
      })),
  };
};
